import React from "react";
import { Link } from "react-router-dom";
import { Localize } from "components/service";
import StaffManagementConst from "../staff-management-const";


const isDefined = (value) => value !== null && value !== undefined;

const StaffManagementWorkersField = ({ id, count, onSiteCount }) => {
    if (!isDefined(count)) return <span>&mdash;</span>;

    const workers = (
        <span className="staff-management-list__workers count">
            { count }
            { isDefined(onSiteCount) &&
                <span className="staff-management-list__on-site">
                    ({ onSiteCount } <Localize>STAFF_MANAGEMENT.Text_OnSite</Localize>)
                </span>
            }
        </span>
    );

    return id && count > 0 ? (
        <div className="view-box-field staff-management-list__workers-view">
            <Link to={ `${ StaffManagementConst.basePath }/${ id }/workers` }>
                { workers }
                <span className="btn-view"><Localize>STAFF_MANAGEMENT.Action_View</Localize></span>
                <span className="visually-hidden"> <Localize>STAFF_MANAGEMENT.Column_Workers</Localize></span>
            </Link>
        </div>
    ) : workers;
};

export default StaffManagementWorkersField;
